import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import { userModule } from "@/store/modules/user";
import ErrorPage from "@/components/404.vue";
import Info from "@/pages/InfoBed.vue";
import InfoAdmin from "@/pages/InfoBedAdmin.vue";
import Informasi from "@/pages/Informasi.vue";
import Login from "@/pages/Login.vue";
import ChangePassword from "@/components/ChangePassword.vue";

function requireAuth(to: TODO, from: TODO, next: TODO) {
  console.log(`userModule.isSignedI ${userModule.isSignedIn}`);
  if (!userModule.isSignedIn) {
    next({
      path: "/login"
      // query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
}

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  { path: "/404", component: ErrorPage, name: "ErrorPage" },
  {
    path: "/info-admin",
    component: InfoAdmin,
    name: "InfoAdmin",
    beforeEnter: requireAuth
  },

  // { path: "/login", component: Login, name: "Login" },
  { path: "/info", component: Info, name: "Info" },
  { path: "/informasi", component: Informasi, name: "Informasi" },
  { path: "*/login", redirect: "/info" },
  {
    path: "/changePassword",
    component: ChangePassword,
    name: "ChangePassword"
  },
  { path: "/", redirect: "/info" },
  { path: "*", redirect: "/404" },

];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  // base: __dirname,
  routes
});

export default router;
